import {Button} from '@luminopia/react-toolbox/lib/button'
import {createValidator, required} from 'core/validation'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Field, FormProps, getFormSubmitErrors, reduxForm} from 'redux-form'
import {FormError} from 'study_coordinator/components/FormError'
import { IState } from 'study_coordinator/store'
import {Link} from 'react-router-dom'
import MultiEmailInput from 'core/components/form/multi-email-input'
import * as styles from './invite-technicians-form.css'

interface ISubmit {
  reviewerId: string
  emails: string
}

export interface IFormFields {
  emails: string
}

interface IStateProps {
  initialValues?: Partial<IFormFields>
  formError?: string
}

interface IDispatchProps {
  onMount?: () => void
}

interface IOwnProps {
  // TODO: The redux-form type for decorated component props is missing onSubmit, so declare it here
  onSubmit: (data: ISubmit) => void
  reviewerId: string
}

export interface IProps extends
  IOwnProps,
  IDispatchProps,
  IStateProps,
  FormProps<IFormFields, IOwnProps, {}> {}

export class InviteTechniciansForm extends React.PureComponent<IProps> {
  public render() {
    const {
      handleSubmit,
      reviewerId
    } = this.props

    return (
      <div className={styles.container}>
        <form
          onSubmit={handleSubmit && handleSubmit((data) => (
            this.props.onSubmit({
              reviewerId,
              emails: data.emails
            })
          ))}
        >
          {this.props.error && (<FormError>{this.props.error}</FormError>)}
          <div className={styles.fieldButtonContainer}>
            <Field name="emails" component={MultiEmailInput} />
            <Button
              type='submit'
              label='Invite'
              raised
              primary
            />
          </div>
        </form>
      </div>
    )
  }

  public componentDidMount() {
    if (this.props.onMount) this.props.onMount()
  }
}

export const inviteTechniciansFormFactory = (name: string) => {
  const mapStateToProps = (state: IState, ownProps: IOwnProps): IStateProps => {
    // TODO: redux-form types are incorrectly implemented. Remove the type cast after fixed
    const errors = getFormSubmitErrors(name)(state) as any
    const formError = errors && errors._error

    return {
      formError,
    }
  }

  const mapDispatchToProps = (dispatch: Dispatch<void>): IDispatchProps => ({
  })

  const formDecorator = reduxForm<IFormFields, IProps>({
    form: name,
    validate: (values, props) => {
      const validator = createValidator<typeof values>({
        emails: [required],
      })
      return validator(values)
    },
    enableReinitialize: true,
  })

  // TODO: I'm not sure why the type of the component is not compatible. Instead of spending tons of time on this,
  // I'm going to just type this as any until we upgrade redux-form in the hopes that might solve the issue.
  const FormDecorated = formDecorator(InviteTechniciansForm as any)

  return connect<IStateProps, IDispatchProps, IOwnProps, IState>(
    mapStateToProps,
    mapDispatchToProps,
  )(FormDecorated)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/technicians/invite-technicians-form.tsx